import { Box, Text } from "@chakra-ui/react"

interface StatCardProps {
  label: string
  value: React.ReactNode
  subline?: React.ReactNode
  onClick?: () => void
}

const StatCard: React.FC<StatCardProps> = ({ label, value, subline, onClick }) => (
  <Box
    bg="gray.100"
    py={4}
    px={6}
    borderRadius="lg"
    textAlign="left"
    cursor={onClick ? "pointer" : undefined}
    role={onClick ? "button" : undefined}
    tabIndex={onClick ? 0 : undefined}
    _hover={onClick ? { bg: "gray.200" } : undefined}
    _focusVisible={onClick ? {
      outline: "2px solid #32544A",
      outlineOffset: "2px",
    } : undefined}
    transition="background 0.15s ease-out"
    onClick={onClick}
    onKeyDown={onClick ? (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault()
        onClick()
      }
    } : undefined}
  >
    <Text fontSize="xs" color="gray.600" mb={1}>{label}</Text>
    <Text fontSize="2xl" fontWeight="semibold" color="gray.900">{value}</Text>
    {subline && <Text fontSize="xs" color="gray.600" mt={1}>{subline}</Text>}
  </Box>
)

export default StatCard
